import { useSoyuzData } from '@spotahome/soyuz/client';

import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  FooterSimplified,
  UserInfoProvider,
  GoogleOneTap,
  AppBanner,
  CitiesProvider,
  HeaderContainer,
  LoginSignupModalWrapper
} from '@spotahome/ui-library';
import ZohoChatbot from '@spotahome/ui-library/src/tenant/components/ZohoChatbot/ZohoChatbot';
import LandingTestimonialsSection from '@spotahome/ui-library/src/tenant/components/LandingTestimonialsSection';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import LandingFaqsSection from '@spotahome/ui-library/src/tenant/components/LandingFaqsSection';

import Hero from './components/Hero';
import HiwSteps from './components/HiwSteps';
import Guarantees from './components/Guarantees';
import Partners from './components/Partners';
import HiwComparison from './components/HiwComparison';
import HiwSocial from './components/HiwSocial';

import { getJsonLdHowTo } from './utils/getJsonLdHowTo';
import { getFaqs, getStructuredFaqs } from './utils/faqs';

const HowItWorksContainer = () => {
  const { [HowItWorksContainer.NAME]: requestedData } = useSoyuzData();
  const { deviceType, deviceViewType, initialCookie, userId } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <CitiesProvider skipAllCities>
            <ToastContainer />
            {!userId && <GoogleOneTap />}
            <AppBanner source="home" deviceType={deviceType} />
            <ZohoChatbot />
            <HeaderContainer />
            <Hero />
            <HiwSteps />
            <Guarantees />
            <LandingTestimonialsSection />
            <HiwComparison />
            <Partners />
            <LandingFaqsSection faqs={getFaqs()} />
            <HiwSocial />
            <FooterSimplified />
            <LoginSignupModalWrapper deviceViewType={deviceViewType} />
          </CitiesProvider>
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

HowItWorksContainer.NAME = 'HowItWorksContainer';

HowItWorksContainer.requestAllData = async req => {
  return {
    headers: {
      scripts: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify(getJsonLdHowTo(req))
        },
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify(getStructuredFaqs(req.trans))
        }
      ]
    },
    data: {
      deviceType: req.device.type,
      deviceViewType: req.device.viewType,
      initialCookie: req.headers.cookie,
      userId: req.userId
    }
  };
};

export default HowItWorksContainer;
